import { render } from "./basic-layout.vue?vue&type=template&id=25f0fb05&scoped=true"
import script from "./basic-layout.vue?vue&type=script&lang=js"
export * from "./basic-layout.vue?vue&type=script&lang=js"

import "./basic-layout.vue?vue&type=style&index=0&id=25f0fb05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f0fb05"]])

export default __exports__